<template>
  <div class="card" style="width:700px;">
    <div class="card-header" layout="row center-spread">
      <!--<input class="form-control index" type="number" :value="data.index"/>-->
      <button class="btn btn-sm btn-secondary" @click="$emit('up')"><i class="fas fa-arrow-up"></i></button>
      <button class="btn btn-sm btn-secondary" style="margin-left: 0.3rem"@click="$emit('down')"><i class="fas fa-arrow-down"></i></button>
      <span self="center" style="margin-left: 1rem; color:white;"><b>{{title}}</b></span>
      <button class="btn btn-danger btn-sm" self="right" @click="$emit('remove')">X</button>
    </div>
    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "cms-shell",
    props: ['data', 'title']
  }
</script>

<style scoped>
  .index {
    width: 5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/CmsShell.vue